import { Checkbox } from '@mui/material';
import { Policy } from '../../../../types/Policy';

const makePolicyPermissionColumn = (policy: Policy, handleChange) => {
  return [
    {
      id: 'selection',
      size: 40,
      cell: ({ row }: any) => (
        <Checkbox
          onChange={async (event) => await handleChange(event, row.original.id)}
          checked={policy.permissionIds.includes(row.original.id)}
          defaultChecked={policy.permissionIds.includes(row.original.id)}
          style={{ padding: 0 }}
        />
      ),
    },
    {
      header: 'Code',
      accessorKey: 'code',
      enableColumnFilter: true,
      size: 250,
    },
  ] as Array<any>;
};
export default makePolicyPermissionColumn;
